import {
  FETCH_RAW_STOCK_REPORT_REQUEST,
  FETCH_RAW_STOCK_REPORT_SUCCESS,
  FETCH_RAW_STOCK_REPORT_FAILURE
} from '../../types/rawStock/rawStockTypes';

const initialState = {
  rows: [],
  totals: { total_qty: 0, total_weight: 0, total_pure_weight: 0 },
  loading: false,
  error: null
};

const rawStockReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RAW_STOCK_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_RAW_STOCK_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        rows: action.payload.rows,
        totals: action.payload.totals,
        error: null
      };
    case FETCH_RAW_STOCK_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default rawStockReportReducer; 